import React from "react"
import {Box, Button, Typography,} from "@mui/material"
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/Check"
import {Trans} from "@lingui/macro"
import {Link} from "react-router-dom"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"

export class PaymentSuccess extends React.Component<{}, {}>
{
	render()
	{
		return (<Box sx={{
			p: 2,
			bgcolor: process.env.REACT_APP_THIRD_COLOR,
		}}>
			<Box
				sx={{
					marginTop: 8,
					display: " flex",
					flexDirection: " column",
					alignItems: " center",
				}}
			>
				<SentimentVeryDissatisfiedIcon color="success"
					sx={{
						fontSize: 120,
						color: "white",
					}} />
				<Typography mt={2} mb={5} variant="h3" sx={{color: "white"}}>
					<Trans id="checkout-success" comment="">Pagamento avvenuto con
						successo</Trans>
				</Typography>
				<Box component={"div"} display={"flex"} justifyContent={"center"}>
					<Link to="/">
						<Button variant="contained" startIcon={<ArrowBackIcon />}>
							<Trans id="checkout-success-back" comment="Go to home"> Torna alla home </Trans>
						</Button>
					</Link>
				</Box>
			</Box>
		</Box>)
	}
}
